class LoadingCtrl {

    constructor($scope, $location, UserService, $routeParams, EVENTS, $window, $rootScope) {

        this.$scope = $scope;
        if(!!$routeParams.returnTo) {
            this.returnTo = $routeParams.returnTo;
        }
        else {
            this.returnTo = "/";
        }

        $scope.timer = window.setInterval(() => {
            if(!!$rootScope.currentUser) {
                window.clearInterval($scope.timer);
                $location.url(this.returnTo);
                $scope.$apply();
            }
        }, 1000);

    }

}

angular.module("cpm")
    .controller("LoadingCtrl", ['$scope', '$location', 'UserService', '$routeParams', 'EVENTS', '$window', '$rootScope', LoadingCtrl]);

